import React, { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import './App.css';
import './css/rozsireneMoznosti.css';
import Navbar from './components/Navbar_menu';
import TopSadzbyBanner from './components/TopSadzbyBanner';
import PorovnavacBank from './PorovnavacBank';
import HypoVstupneParametre from './components/kalkulacka/HypoVstupneParametre';
import HypoZiadatelia from './components/kalkulacka/HypoZiadatelia';
import HypoZavazky from './components/kalkulacka/CelkoveZavazky';
import PoznamkaKarta from './components/kalkulacka/PoznamkaKarta';
import RozsireneMoznostiKarta from './components/kalkulacka/RozsireneMoznostiKarta';
import VypoctyKarta from './components/kalkulacka/VypoctyKarta';
import VyvojGrafKarta from './components/kalkulacka/VyvojGrafKarta';
import PredcasneSplatenieVstupKarta from './components/kalkulacka/PredcasneSplatenieVstupKarta';
import PredcasneSplatenieVystupKarta from './components/kalkulacka/PredcasneSplatenieVystupKarta';
import InvestovanieVstupKarta from './components/kalkulacka/InvestovanieVstupKarta';
import InvestovanieVystupKarta from './components/kalkulacka/InvestovanieVystupKarta';
import SplatkovyKalendarKarta from './components/kalkulacka/SplatkovyKalendarKarta';
import ExportPonukaPdfModal from './components/kalkulacka/ExportPonukaPdfModal';
import { vypocitajFinCloudTip } from './utils/fincloudTip';
import { vypocitajVysledokInvestovania } from './utils/investovanie';
import { vytvorDataPrePonukuPdf } from './utils/ponukaPdfData';
import { exportPonukaPdf } from './utils/exportPonukaPdf';
import { resetujHypotekarnuKalkulacku } from './utils/resetHypotekarnaKalkulacka';
import { useAuth } from './auth/AuthContext';
import { apiUrl } from './config/apiBase';
import { useDorovnajKarty } from './hooks/useDorovnajKarty';
import { vypocitajDtiPreVsetkychZiadatelov, vypocitajHypostressSplatkyPreVsetkychZiadatelov, vypocitajDstiPreVsetkychZiadatelov, vypocitajStressDtiMaxUver } from './utils/dtiDsti';
//Developed by MK Finance & Digital s.r.o.

// Komponenty - Hlavný Graf
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

//hlavná kalkulačka

function HypotekarnaKalkulacka() {
  const { user } = useAuth();
  const [urok, setUrok] = useState(3.50);
  //const [urokInput, setUrokInput] = useState(() => urok.toFixed(2).replace('.', ','));
  const [suma, setSuma] = useState(100000);
  const [roky, setRoky] = useState(30);
  const [splatka, setSplatka] = useState(null);
  const [zostatky, setZostatky] = useState([]);
  const [hodnotazabezpecenia, setHodnotazabezpecenia] = useState(150000);
  const [fixacia, setFixacia] = useState(3);
  const [fixacieRocne, setFixacieRocne] = useState([]);
  const [topSadzby, setTopSadzby] = useState([]); 
  const [pocetziadatelov, setPocetziadatelov] = useState(1);
  const [pocetdeti, setPocetdeti] = useState(0);
  const [pocetdeti2, setPocetdeti2] = useState(0);
  const [pocetdeti3, setPocetdeti3] = useState(0);
  const [pocetdeti4, setPocetdeti4] = useState(0);
  const [spolocnadomacnost1, setSpolocnadomacnost1] = useState(false);
  const [spolocnadomacnost2, setSpolocnadomacnost2] = useState(false);
  const [prijem1, setPrijem1] = useState(1500);
  const [vek1, setVek1] = useState(30);
  const [prijem2, setPrijem2] = useState(0);
  const [vek2, setVek2] = useState(0);
  const [prijem3, setPrijem3] = useState(0);
  const [vek3, setVek3] = useState(0);
  const [prijem4, setPrijem4] = useState(0);
  const [vek4, setVek4] = useState(0);
  const [aktivnyZiadatelTab, setAktivnyZiadatelTab] = useState(1);
  const [Hypoobjem, setHypoobjem] = useState(0);
  const [Hyposplatnost, setHyposplatnost] = useState(0);
  const [Hyposadzba, setHyposadzba] = useState(0);
  const [Hyposplatka, setHyposplatka] = useState(0);
  const [Hypofixacia, setHypofixacia] = useState(0);
  const [Ostatneobjem, setOstatneobjem] = useState(0);
  const [Ostatnesplatka, setOstatnesplatka] = useState(0);
  const [dtiVysledok, setDtiVysledok] = useState(null);
  const [stresssplatka, setStresssplatka] = useState(null);
  const [dstistresssplatka, setDstistresssplatka] = useState(null);
  const [stressdti, setStressdti] = useState(null);
  const [typHypoteky, setTypHypoteky] = useState('nadobudnutie');
  const [ltvMoznosti, setLtvMoznosti] = useState(null);
  const [ppOpen, setPpOpen] = useState(false);   
  const [ppJednoraz, setPpJednoraz] = useState(0); 
  const [ppMesacne, setPpMesacne] = useState(0); 
  const [ppRocne, setPpRocne] = useState(0); 
  const [ppStart, setPpStart] = useState(0); 
  const [ppOpakovania, setPpOpakovania] = useState(0);           
  const [ppRezim, setPpRezim] = useState('skratenie');
  const [invOpen, setInvOpen] = useState(false);
  const [invJednoraz, setInvJednoraz] = useState(0);     
  const [invMesacne, setInvMesacne] = useState(0);       
  const [invZhodnotenie, setInvZhodnotenie] = useState(6.0); 
  const [invHorizont, setInvHorizont] = useState(roky);       
  const [skalRezim, setSkalRezim] = useState(null);
  const [invProfil, setInvProfil] = useState('vyvazeny');
  const [invVystupPS, setInvVystupPS] = useState(false);
  const doCentov = (x) => Math.round((Number(x) || 0) * 100);
  const [aktivnyZavazkyTab, setAktivnyZavazkyTab] = useState(1);
  // Celkové záväzky – sufix 2
  const [Hypoobjem2, setHypoobjem2] = useState(0);
  const [Hyposplatnost2, setHyposplatnost2] = useState(0);
  const [Hyposadzba2, setHyposadzba2] = useState(0);
  const [Hyposplatka2, setHyposplatka2] = useState(0);
  const [Hypofixacia2, setHypofixacia2] = useState(0);
  const [Ostatneobjem2, setOstatneobjem2] = useState(0);
  const [Ostatnesplatka2, setOstatnesplatka2] = useState(0);

  const [Hypoobjem3, setHypoobjem3] = useState(0);
  const [Hyposplatnost3, setHyposplatnost3] = useState(0);
  const [Hyposadzba3, setHyposadzba3] = useState(0);
  const [Hyposplatka3, setHyposplatka3] = useState(0);
  const [Hypofixacia3, setHypofixacia3] = useState(0);
  const [Ostatneobjem3, setOstatneobjem3] = useState(0);
  const [Ostatnesplatka3, setOstatnesplatka3] = useState(0);

  const [Hypoobjem4, setHypoobjem4] = useState(0);
  const [Hyposplatnost4, setHyposplatnost4] = useState(0);
  const [Hyposadzba4, setHyposadzba4] = useState(0);
  const [Hyposplatka4, setHyposplatka4] = useState(0);
  const [Hypofixacia4, setHypofixacia4] = useState(0);
  const [Ostatneobjem4, setOstatneobjem4] = useState(0);
  const [Ostatnesplatka4, setOstatnesplatka4] = useState(0);

  const [zmJednotlivec, setZmJednotlivec] = useState(295.22);
  const [zmDruhyDospely, setZmDruhyDospely] = useState(205.96);
  const [zmDieta, setZmDieta] = useState(134.80);
  const [poznamka, setPoznamka] = useState('');

  const [nazovSuboruPdf, setNazovSuboruPdf] = useState('Ponuka_hypoteka');
  const [menoKlientaPdf, setMenoKlientaPdf] = useState('');

  const [pdfModalOtvoreny, setPdfModalOtvoreny] = useState(false);
  const [pdfSekcie, setPdfSekcie] = useState({
    zahrnutPredcasneSplatenie: ppOpen,
    zahrnutInvestovanie: invOpen,
    zahrnutGraf: true,
    zahrnutSplatkovyKalendar: false,
    zahrnutPorovnavac: true,
    zahrnutPoznamku: Boolean((poznamka || '').trim()),
  });

  const [porovnavacDataPrePdf, setPorovnavacDataPrePdf] = useState({
    banky: [],
    zobrazeneBanky: [],
    zoznamBank: [],
    vybraneBanky: {},
    vsetkyBanky: true,
    maUcet: true,
    maPoistenieUveru: true,
    maPoistenieNehnutelnosti: true,
    maEkoCertifikat: true,
    fixacia: null,
    suma: 0,
    roky: 0,
    ltvPercenta: null,
    jeLoading: false,
    chyba: null,
  });

  const fincloudTip = React.useMemo(() => {
    const t = vypocitajFinCloudTip(suma, roky, zostatky);

    // DÔLEŽITÉ: nikdy nevracaj null, aby render nepadal
    if (t && Array.isArray(t.tipy) && t.sablona) return t;

    return { tipy: [], sablona: { pred: "", pred2: "", stred: "", za: "", za2: "", } };
  }, [suma, roky, zostatky]);

  const maFincloudTip = Array.isArray(fincloudTip?.tipy) && fincloudTip.tipy.length === 2;

  const fincloudTipPlaceholder = React.useMemo(
    () => [{ faza: "__placeholder_1" }, { faza: "__placeholder_2" }],
    []
  );

  // ACTION ROW (RESET + ULOŽ PONUKU PDF)
  const resetujAplikaciu = () => {
    resetujHypotekarnuKalkulacku({
      setUrok,
      setSuma,
      setRoky,
      setHodnotazabezpecenia,
      setFixacia,

      setPocetziadatelov,
      setPocetdeti,
      setPocetdeti2,
      setPocetdeti3,
      setPocetdeti4,

      setSpolocnadomacnost1,
      setSpolocnadomacnost2,

      setPrijem1,
      setVek1,
      setPrijem2,
      setVek2,
      setPrijem3,
      setVek3,
      setPrijem4,
      setVek4,

      setAktivnyZiadatelTab,
      setAktivnyZavazkyTab,

      setHypoobjem,
      setHyposplatnost,
      setHyposadzba,
      setHyposplatka,
      setHypofixacia,
      setOstatneobjem,
      setOstatnesplatka,

      setHypoobjem2,
      setHyposplatnost2,
      setHyposadzba2,
      setHyposplatka2,
      setHypofixacia2,
      setOstatneobjem2,
      setOstatnesplatka2,

      setHypoobjem3,
      setHyposplatnost3,
      setHyposadzba3,
      setHyposplatka3,
      setHypofixacia3,
      setOstatneobjem3,
      setOstatnesplatka3,

      setHypoobjem4,
      setHyposplatnost4,
      setHyposadzba4,
      setHyposplatka4,
      setHypofixacia4,
      setOstatneobjem4,
      setOstatnesplatka4,

      setTypHypoteky,
      setLtvMoznosti,

      setPpOpen,
      setPpJednoraz,
      setPpMesacne,
      setPpRocne,
      setPpStart,
      setPpOpakovania,
      setPpRezim,

      setInvOpen,
      setInvJednoraz,
      setInvMesacne,
      setInvZhodnotenie,
      setInvHorizont,
      setSkalRezim,
      setInvProfil,
      setInvVystupPS,

      setZmJednotlivec,
      setZmDruhyDospely,
      setZmDieta,

      setPoznamka,

      setNazovSuboruPdf,
      setMenoKlientaPdf,
      setPdfModalOtvoreny,
      setPdfSekcie,
      setPorovnavacDataPrePdf,
    });
  };

  const otvorPdfModal = () => {
    setPdfSekcie({
      zahrnutPredcasneSplatenie: ppOpen,
      zahrnutInvestovanie: invOpen,
      zahrnutGraf: true,
      zahrnutSplatkovyKalendar: false,
      zahrnutPorovnavac: true,
      zahrnutPoznamku: Boolean((poznamka || '').trim()),
    });

    setPdfModalOtvoreny(true);
  };

  const ulozPonukuPdf = async () => {
    const dataPrePdf = vytvorDataPrePonukuPdf({
      nazovSuboru: nazovSuboruPdf,
      menoKlienta: menoKlientaPdf,
      kontaktMeno: user?.name || '',
      kontaktPriezvisko: user?.priezvisko || '',
      kontaktEmail: user?.email || '',
      kontaktTelefon: user?.telefon || '',
      kontaktNbsCislo: user?.nbsCislo || '',
      suma,
      hodnotazabezpecenia,
      urok,
      fixacia,
      roky,
      splatka,
      stresssplatka,
      dtiVysledok,
      stressdti,
      dstistresssplatka,
      typHypoteky,
      pocetziadatelov,

      pocetdeti,
      pocetdeti2,
      pocetdeti3,
      pocetdeti4,
      vek1,
      prijem1,
      vek2,
      prijem2,
      vek3,
      prijem3,
      vek4,
      prijem4,
      Hypoobjem,
      Hyposplatnost,
      Hyposadzba,
      Hyposplatka,
      Hypofixacia,
      Ostatneobjem,
      Ostatnesplatka,
      Hypoobjem2,
      Hyposplatnost2,
      Hyposadzba2,
      Hyposplatka2,
      Hypofixacia2,
      Ostatneobjem2,
      Ostatnesplatka2,
      Hypoobjem3,
      Hyposplatnost3,
      Hyposadzba3,
      Hyposplatka3,
      Hypofixacia3,
      Ostatneobjem3,
      Ostatnesplatka3,
      Hypoobjem4,
      Hyposplatnost4,
      Hyposadzba4,
      Hyposplatka4,
      Hypofixacia4,
      Ostatneobjem4,
      Ostatnesplatka4,

      poznamka,
      fincloudTip,
      ppOpen,
      ppRezim,
      ppJednoraz,
      ppMesacne,
      ppRocne,
      ppStart,
      ppOpakovania,
      resultA,
      resultB,
      exceededRelevant,
      invOpen,
      invProfil,
      invJednoraz,
      invMesacne,
      invZhodnotenie,
      invHorizont,
      invVystupPS,
      vysledokInvestovania,
      splatkovyKalendar,
      splatkovyKalendarPS_skratenie,
      splatkovyKalendarPS_znizenie,
      investicnyPriebeh,
      porovnavacDataPrePdf,
      chartRef,
    });

    await exportPonukaPdf(dataPrePdf, pdfSekcie);
    setPdfModalOtvoreny(false);
  };

  const limitLTV =
    typHypoteky === 'refinancovanie' ? 100 :
    typHypoteky === 'bezucel'     ? 80  : 90;

  const jeNizkaHodnota = (() => {
    const u = Math.max(0, Number(suma) || 0);
    const h = Math.max(1, Number(hodnotazabezpecenia) || 1);
    return (u * 100) > (limitLTV * h);
  })();

  const vypocitajSplatku = useCallback(() => {
    const r = Number(urok) / 100 / 12;
    const n = Math.max(1, Number(roky) * 12);
    const P = Math.max(0, Number(suma) || 0);

    const M = r === 0 ? (P / n) : (P * r * Math.pow(1 + r, n) / (Math.pow(1 + r, n) - 1));
    setSplatka(M.toFixed(2));

    let zostatok = P;
    const zostatkyArray = [];
    for (let i = 1; i <= n; i++) {
      const urokovaCast = r === 0 ? 0 : zostatok * r;
      const istina = Math.min(M - urokovaCast, zostatok);
      zostatok = Math.max(0, zostatok - istina);
      zostatkyArray.push(zostatok > 0 ? zostatok.toFixed(2) : 0);
      if (zostatok <= 0) break;
    }
    setZostatky(zostatkyArray);
  }, [urok, roky, suma]);

  const ziadateliaDti = React.useMemo(() => ([
    {
        vek: vek1,
        prijem: prijem1,
        hypoobjem: Hypoobjem,
        ostatneobjem: Ostatneobjem,
      },
      {
        vek: vek2,
        prijem: prijem2,
        hypoobjem: Hypoobjem2,
        ostatneobjem: Ostatneobjem2,
      },
      {
        vek: vek3,
        prijem: prijem3,
        hypoobjem: Hypoobjem3,
        ostatneobjem: Ostatneobjem3,
      },
      {
        vek: vek4,
        prijem: prijem4,
        hypoobjem: Hypoobjem4,
        ostatneobjem: Ostatneobjem4,
      },
    ]), [
      vek1,
      prijem1,
      Hypoobjem,
      Ostatneobjem,

      vek2,
      prijem2,
      Hypoobjem2,
      Ostatneobjem2,

      vek3,
      prijem3,
      Hypoobjem3,
      Ostatneobjem3,

      vek4,
      prijem4,
      Hypoobjem4,
      Ostatneobjem4,
    ]);

    const ziadateliaStressDsti = React.useMemo(() => ([
      {
        vek: vek1,
        prijem: prijem1,
        pocetdeti: pocetdeti,
        hypoobjem: Hypoobjem,
        hyposplatnost: Hyposplatnost,
        hyposadzba: Hyposadzba,
        hyposplatka: Hyposplatka,
        hypofixacia: Hypofixacia,
        ostatnesplatka: Ostatnesplatka,
      },
      {
        vek: vek2,
        prijem: prijem2,
        pocetdeti: pocetdeti2,
        hypoobjem: Hypoobjem2,
        hyposplatnost: Hyposplatnost2,
        hyposadzba: Hyposadzba2,
        hyposplatka: Hyposplatka2,
        hypofixacia: Hypofixacia2,
        ostatnesplatka: Ostatnesplatka2,
      },
      {
        vek: vek3,
        prijem: prijem3,
        pocetdeti: pocetdeti3,
        hypoobjem: Hypoobjem3,
        hyposplatnost: Hyposplatnost3,
        hyposadzba: Hyposadzba3,
        hyposplatka: Hyposplatka3,
        hypofixacia: Hypofixacia3,
        ostatnesplatka: Ostatnesplatka3,
      },
      {
        vek: vek4,
        prijem: prijem4,
        pocetdeti: pocetdeti4,
        hypoobjem: Hypoobjem4,
        hyposplatnost: Hyposplatnost4,
        hyposadzba: Hyposadzba4,
        hyposplatka: Hyposplatka4,
        hypofixacia: Hypofixacia4,
        ostatnesplatka: Ostatnesplatka4,
      },
    ]), [
      vek1,
      prijem1,
      pocetdeti,
      Hypoobjem,
      Hyposplatnost,
      Hyposadzba,
      Hyposplatka,
      Hypofixacia,
      Ostatnesplatka,

      vek2,
      prijem2,
      pocetdeti2,
      Hypoobjem2,
      Hyposplatnost2,
      Hyposadzba2,
      Hyposplatka2,
      Hypofixacia2,
      Ostatnesplatka2,

      vek3,
      prijem3,
      pocetdeti3,
      Hypoobjem3,
      Hyposplatnost3,
      Hyposadzba3,
      Hyposplatka3,
      Hypofixacia3,
      Ostatnesplatka3,

      vek4,
      prijem4,
      pocetdeti4,
      Hypoobjem4,
      Hyposplatnost4,
      Hyposadzba4,
      Hyposplatka4,
      Hypofixacia4,
      Ostatnesplatka4,
    ]);

  const prepocetDTI = useCallback(() => {
    return vypocitajDtiPreVsetkychZiadatelov({
      pocetziadatelov,
      splatnostRoky: roky,
      ziadatelia: ziadateliaDti,
    });
  }, [pocetziadatelov, roky, ziadateliaDti]);

  const vypocitajStressSplatku = useCallback(() => {
    const stressUrok = fixacia >= 10 ? urok + 1 : urok + 2;
    const finalstressUrok = Math.min(stressUrok, 6);
    const rr = finalstressUrok / 100 / 12;
    const n = roky * 12;
    const P = parseFloat(suma);

    const M = P * rr * Math.pow(1 + rr, n) / (Math.pow(1 + rr, n) - 1);
    setStresssplatka(M.toFixed(2));
  }, [fixacia, urok, roky, suma]);

  const hypostressSplatky = React.useMemo(() => {
    return vypocitajHypostressSplatkyPreVsetkychZiadatelov({
      pocetziadatelov,
      ziadatelia: ziadateliaStressDsti,
    });
  }, [pocetziadatelov, ziadateliaStressDsti]);

  const prepocetDSTI = useCallback(() => {
    const dsti = vypocitajDstiPreVsetkychZiadatelov({
      pocetziadatelov,
      ziadatelia: ziadateliaStressDsti,
      hypostressSplatky,
      spolocnadomacnost1,
      spolocnadomacnost2,
      zmJednotlivec,
      zmDruhyDospely,
      zmDieta,
    });

    setDstistresssplatka(dsti.toFixed(2));
  }, [
    pocetziadatelov,
    ziadateliaStressDsti,
    hypostressSplatky,
    spolocnadomacnost1,
    spolocnadomacnost2,
    zmJednotlivec,
    zmDruhyDospely,
    zmDieta,
  ]);

  const vypocitajStressDTI = useCallback(() => {
    const objem = vypocitajStressDtiMaxUver({
      fixacia,
      urok,
      roky,
      dstistresssplatka,
    });

    setStressdti(objem);
  }, [fixacia, urok, roky, dstistresssplatka]);


  const vysledokInvestovania = React.useMemo(() => {
  return vypocitajVysledokInvestovania({
    invOpen,
    invJednoraz,
    invMesacne,
    invZhodnotenie,
    invHorizont,
    roky,
    zostatky,
  });
}, [invOpen, invJednoraz, invMesacne, invZhodnotenie, invHorizont, roky, zostatky]);


useEffect(() => {
  vypocitajSplatku();
  const dti = prepocetDTI(); 
  setDtiVysledok(Math.round(dti)); 
  vypocitajStressSplatku();
  prepocetDSTI();
  vypocitajStressDTI();
}, [vypocitajSplatku, prepocetDTI, vypocitajStressSplatku, prepocetDSTI, vypocitajStressDTI]);

  useEffect(() => {
    if (!ltvMoznosti) return;                     
    const loan = Number(suma) || 0;
      if (loan > 0) {
      const val = Math.ceil(loan / (ltvMoznosti / 100));
      setHodnotazabezpecenia(val);
    }
  }, [suma, ltvMoznosti]);

 useEffect(() => {
  (async () => {
    const fallback = [1, 2, 3, 4, 5, 6, 7, 8, 10, 15];

    try {
      const res = await fetch(apiUrl('/api/fixacie/rocne'), {
        credentials: 'include'
      });

      if (!res.ok) {
        console.error('API /api/fixacie/rocne vrátilo chybu:', res.status);
        setFixacieRocne(fallback);
        return;
      }

      const data = await res.json();
      const arr = Array.isArray(data.fixacie) ? data.fixacie : [];

      const ciste = arr
        .map((v) => Number(v))
        .filter((v) => Number.isFinite(v) && v > 0)
        .sort((a, b) => a - b);

      if (!ciste.length) {
        setFixacieRocne(fallback);
      } else {
        setFixacieRocne(ciste);
      }
    } catch (e) {
      console.error('Chyba načítania fixácií:', e);
      setFixacieRocne(fallback);
    }
  })();
}, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(apiUrl('/api/uroky/top-sadzby?limit=30'), {
          credentials: 'include',
        });

        if (!res.ok) {
          console.error('API /api/uroky/top-sadzby vrátilo chybu:', res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.top)) {
          setTopSadzby(data.top);
        }
      } catch (e) {
        console.error('Chyba načítania TOP sadzieb:', e);
      }
    })();
  }, []);

  // Predcasne splatenie 
  const limitPP = 0.30; // 30 % ročne z istiny (zostatku) 
  
  const celkovoMesiacovPP = Math.max(0, (Number(roky) || 0) * 12);
  const startMoznost = Array.from({ length: celkovoMesiacovPP }, (_, i) => i + 1);
  const ppStartEfekt = Math.min(
    Math.max(Number(ppStart) || 0, 0),
    Math.max(celkovoMesiacovPP - 1, 0)
  );

  useEffect(() => {
    if (!ppOpen) return;

    if ((Number(ppOpakovania) || 0) === 0) {
      const mesiace = Math.max(0, (Number(roky) || 0) * 12 - (Number(ppStart) || 0));
      const maxOpak = Math.floor((mesiace + 11) / 12);
      if (maxOpak > 0) setPpOpakovania(maxOpak);
    }
  }, [ppOpen, roky, ppStart, ppOpakovania]);

  // Celkové záväzky – taby dostupnost
  useEffect(() => {
    const maxPovolenyTab = Math.max(1, Number(pocetziadatelov) || 1);

    if (aktivnyZavazkyTab > maxPovolenyTab) {
      setAktivnyZavazkyTab(maxPovolenyTab);
    }
  }, [pocetziadatelov, aktivnyZavazkyTab]);
  
  
  const mesiaceOdStartu = Math.max(0, celkovoMesiacovPP - ppStartEfekt);
  const maxOpakovani = Math.floor((mesiaceOdStartu + 11) / 12);
  const opakovaniaMoznost = Array.from({ length: maxOpakovani }, (_, i) => i + 1);

  const repeatValueEfekt = Math.min(
    Math.max((Number(ppOpakovania) || maxOpakovani), 1),
    maxOpakovani
  );

  const ppDraft = React.useMemo(() => {
  const evts = [];
  if (!ppOpen) return evts;

  const zaciatokPP = Math.min(Math.max(0, Number(ppStartEfekt) || 0), Math.max(celkovoMesiacovPP - 1, 0));

  // Jednorazovo PS
  if ((Number(ppJednoraz) || 0) > 0 && zaciatokPP < celkovoMesiacovPP) {
    evts.push({ m: zaciatokPP, amt: Number(ppJednoraz), kind: 'once' });
  }

  // Pravidelne mesačne PS
  if ((Number(ppMesacne) || 0) > 0 && zaciatokPP < celkovoMesiacovPP) {
    const months = Math.min(celkovoMesiacovPP - zaciatokPP, (Number(repeatValueEfekt) || 0) * 12);
    for (let i = 0; i < months; i++) {
      evts.push({ m: zaciatokPP + i, amt: Number(ppMesacne), kind: 'monthly' });
    }
  }

  // Pravidelne ročne PS
  if ((Number(ppRocne) || 0) > 0 && zaciatokPP < celkovoMesiacovPP) {
    const years = Math.min(Math.ceil((celkovoMesiacovPP - zaciatokPP) / 12), Number(repeatValueEfekt) || 0);
    for (let y = 0; y < years; y++) {
      const mm = zaciatokPP + y * 12;
      if (mm < celkovoMesiacovPP) evts.push({ m: mm, amt: Number(ppRocne), kind: 'yearly' });
    }
  }

  evts.sort((a, b) => a.m - b.m);
  return evts;
}, [ppOpen, ppJednoraz, ppMesacne, ppRocne, ppStartEfekt, repeatValueEfekt, celkovoMesiacovPP]);


const ppClamped = React.useMemo(() => {
  if (!ppDraft.length) return { events: [], exceeded: [], caps: [], usedByYear: [] };

  const years = Math.ceil(celkovoMesiacovPP / 12);
  const caps = [];
  for (let y = 0; y < years; y++) {
    const yearStartM = y * 12;
    const principalAtStart =
      y === 0 ? (Number(suma) || 0)
              : (Number(zostatky[yearStartM - 1]) || 0); 
    caps[y] = Math.max(0, Math.floor(principalAtStart * limitPP));
  }

  const used = new Array(years).fill(0);
  const out = [];
  const exceeded = []; 

  for (const e of ppDraft) {
    const y = Math.floor(e.m / 12);
    const cap = caps[y] ?? 0;
    const left = cap - used[y];
    if (left <= 0) {
      exceeded.push({ year: y, month: e.m, overBy: e.amt });
      continue;
    }
    const take = Math.min(e.amt, left);
    out.push({ ...e, amt: take });
    used[y] += take;

    if (e.amt > take) {
      exceeded.push({ year: y, month: e.m, overBy: e.amt - take });
    }
  }

  return { events: out, exceeded, caps, usedByYear: used };
}, [ppDraft, zostatky, celkovoMesiacovPP, suma, limitPP]);

// pomocné výpočty k PS výstupy
const fmtMesiace = (m) => {
  const y = Math.floor((Number(m) || 0) / 12);
  const mm = (Number(m) || 0) % 12;
  return `${y} r ${mm} m`;
};

const rozdielMesiacov = (z) => {
  const r = Math.max(0, Number(z) || 0);
  const roky = Math.floor(r / 12);
  const mesiace = r % 12;
  return `${roky} r ${mesiace} m`;
};

const preplatenieBezPS = React.useMemo(() => {
  const r = (Number(urok) || 0) / 100 / 12;
  const n = Math.max(1, (Number(roky) || 0) * 12);
  const P = Math.max(0, Number(suma) || 0);

  const M0 = r === 0
    ? (P / n)
    : (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);

  return Math.max(0, M0 * n - P);
}, [urok, roky, suma]);

const resultA = React.useMemo(() => {
  if (!ppOpen || !ppClamped || !ppClamped.events || ppClamped.events.length === 0) return null;

  const r = (Number(urok) || 0) / 100 / 12;
  const n = Math.max(1, (Number(roky) || 0) * 12);
  const P = Math.max(0, Number(suma) || 0);

  const M = r === 0 ? (P / n) : P * r * Math.pow(1 + r, n) / (Math.pow(1 + r, n) - 1);
  const baseInterest = r === 0 ? 0 : (M * n - P);

  const evMap = new Map();
  for (const e of ppClamped.events) {
    evMap.set(e.m, (evMap.get(e.m) || 0) + Number(e.amt || 0));
  }

  let bal = P;
  let totalInt = 0;
  const balances = [];

  for (let m = 0; m < n && bal > 0.005; m++) {
    const interest = bal * r;
    const schedPay = r === 0 ? Math.min(M, bal) : Math.min(M, bal + interest);
    const princ = schedPay - interest;
    bal = Math.max(0, bal - princ);

    const extra = evMap.get(m) || 0;
    if (extra > 0) {
      bal = Math.max(0, bal - extra);
    }

    totalInt += Math.max(0, interest);
    balances.push(+bal.toFixed(2));
  }

  const payoffMonth = balances.length;           
  const monthsSaved = Math.max(0, n - payoffMonth);
  const savedInterest = Math.max(0, (baseInterest || 0) - totalInt);

  return {
    payoffMonth,
    monthsSaved,
    savedInterest,
    totalInterestBase: Math.max(0, baseInterest),
    totalInterestPP: Math.max(0, totalInt),
    totalPaidBase: Math.max(0, P + baseInterest),
    totalPaidPP: Math.max(0, P + totalInt),
    balances,              
    baselineMonths: n,
    nastaloPP: payoffMonth < n,
    dlzkaMesiace: payoffMonth < n ? payoffMonth : n,
    uroky: Math.max(0, totalInt),
    usporaNaUrokoch: Math.max(0, baseInterest - totalInt),
  };
}, [ppOpen, ppClamped, urok, roky, suma]);


//variant B
const annuitnaSplatka = (P, r, n) => {
  if (n <= 0) return P;              
  if (r === 0) return P / n;
  const a = Math.pow(1 + r, n);
  return (P * r * a) / (a - 1);
};

// VARIANT B: znižovať splátku (recalc po každom PS)
const resultB = React.useMemo(() => {
  if (!ppOpen || !ppClamped?.events?.length) return null;

  const r = (Number(urok) || 0) / 100 / 12;
  const n = Math.max(1, (Number(roky) || 0) * 12);
  const P0 = Math.max(0, Number(suma) || 0);

  const M0 = annuitnaSplatka(P0, r, n);
  const baseInterest = r === 0 ? 0 : (M0 * n - P0);

  const evMap = new Map();
  for (const e of ppClamped.events) {
    evMap.set(e.m, (evMap.get(e.m) || 0) + Number(e.amt || 0));
  }

  let bal = P0;
  let Mcur = annuitnaSplatka(bal, r, n);      
  let totalInt = 0;
  const balances = [];
  const payments = [];                 
  let payoffMonth = 0;
  let firstNewPayment = null;          

  for (let m = 0; m < n && bal > 0.005; m++) {
    const interest = bal * r;
    const schedPay = r === 0 ? Math.min(Mcur, bal) : Math.min(Mcur, bal + interest);
    const princ = schedPay - interest;
    bal = Math.max(0, bal - princ);
    totalInt += Math.max(0, interest);

    const extra = evMap.get(m) || 0;
    if (extra > 0) {
      bal = Math.max(0, bal - extra);
      if (firstNewPayment === null) {
        const rem = Math.max(0, n - (m + 1));
        firstNewPayment = annuitnaSplatka(bal, r, rem);
      }
    }

    const rem = Math.max(0, n - (m + 1));
    Mcur = annuitnaSplatka(bal, r, rem);

    payments.push(+Mcur.toFixed(2));
    balances.push(+bal.toFixed(2));
    payoffMonth = m + 1;
  }

  const totalInterest = totalInt;
  const savedInterest = Math.max(0, (baseInterest || 0) - totalInterest);
  const avgPayment = payments.length ? (payments.reduce((a, b) => a + b, 0) / payments.length) : 0;

  return {
    payoffMonth,            
    totalInterest,          
    savedInterest, 
    totalInterestBase: Math.max(0, baseInterest),
    totalInterestPP: Math.max(0, totalInterest),
    totalPaidBase: Math.max(0, P0 + baseInterest),
    totalPaidPP: Math.max(0, P0 + totalInterest),         
    firstNewPayment: firstNewPayment ?? (payments[0] || 0),
    avgPayment,
    payments,
    balances,
    baselineMonths: n,
    nastaloPP: payoffMonth < n,
    dlzkaMesiace: payoffMonth < n ? payoffMonth : n,
    uroky: Math.max(0, totalInterest),
    usporaNaUrokoch: Math.max(0, baseInterest - totalInterest),
  };
}, [ppOpen, ppClamped, urok, roky, suma]);

const payoffMonthAktualnyPS =
  ppRezim === 'skratenie'
    ? (resultA?.payoffMonth ?? null)
    : (resultB?.payoffMonth ?? null);

const exceededRelevant = React.useMemo(() => {
  if (!ppClamped?.exceeded?.length) return [];

  if (!payoffMonthAktualnyPS || payoffMonthAktualnyPS <= 0) {
    return ppClamped.exceeded;
  }

  return ppClamped.exceeded.filter((e) => Number(e.month) < Number(payoffMonthAktualnyPS));
}, [ppClamped, payoffMonthAktualnyPS]);

const data = React.useMemo(() => {
  const baseArr = (zostatky || []).map((v) => Number(v));
  const investArr = (vysledokInvestovania?.priebehKrivky || []).map((v) => Number(v));
  const len = Math.max(baseArr.length, investArr.length);
  const labels = Array.from({ length: len }, (_, i) => i + 1);

  const pad = (arr = []) =>
    (arr.length >= len ? arr.slice(0, len) : [...arr, ...Array(len - arr.length).fill(0)]);

  const ds = [
    {
      label: 'Zostatok úveru (€)',
      data: baseArr,
      fill: false,
      borderColor: 'rgb(75, 192, 192)',
      tension: 0.1,
      pointRadius: 0,
      borderWidth: 1.6,
      spanGaps: false,
    }
  ];

  if (Array.isArray(fincloudTip?.tipy) && fincloudTip.tipy.length) {
    const zoradeneTipy = [...fincloudTip.tipy]
      .sort((a, b) => (Number(b?.rokyCiel) || 0) - (Number(a?.rokyCiel) || 0))
      .slice(0, 2);

    zoradeneTipy.forEach((tip, idx) => {
      if (!Array.isArray(tip?.priebehKrivky) || !tip.priebehKrivky.length) return;

      ds.push({
        label: `FC Tip ${idx + 1} (€)`,
        data: pad(tip.priebehKrivky),
        fill: false,
        borderColor: idx === 0 ? 'rgba(156, 139, 96, 0.95)' : 'rgba(100, 171, 210, 0.95)',
        borderDash: [6, 4],
        tension: 0.18,
        pointRadius: 0,
        borderWidth: 1.6,
        spanGaps: false,
      });
    });
  }

  if (vysledokInvestovania?.priebehKrivky) {
    ds.push({
      label: 'Sporenie / investovanie (€)',
      data: pad(vysledokInvestovania.priebehKrivky),
      fill: false,
      borderColor: 'rgba(255, 206, 86, 0.95)',
      tension: 0.18,
      pointRadius: 0,
      borderWidth: 1.6,
      spanGaps: false,
    });
  }

  if (ppOpen && ppClamped?.events?.length) {
    if (ppRezim === 'skratenie' && resultA?.balances) {
      ds.push({
        label: 'S PS (skrátenie)',
        data: pad(resultA.balances),
        fill: false,
        borderColor: 'rgba(20,201,201,.95)',
        tension: 0.18,
        pointRadius: 0,
        borderWidth: 1.6,
        spanGaps: false,
      });
    }
    if (ppRezim === 'znizenie' && resultB?.balances) {
      ds.push({
        label: 'S PS (zníženie splátky)',
        data: pad(resultB.balances),
        fill: false,
        borderColor: 'rgba(20,201,201,.95)',
        tension: 0.18,
        pointRadius: 0,
        borderWidth: 1.6,
        spanGaps: false,
      });
    }
  }

  return { labels, datasets: ds };
}, [zostatky, fincloudTip, vysledokInvestovania, ppOpen, ppClamped, ppRezim, resultA, resultB]);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'bottom' }
  },
  layout: {
    padding: {
      bottom: 0
    }
  }
};

// Splátkový kalendár
const annuitnaSplatkaCenty = (Pcent, r, n) => {
  if (n <= 0) return Pcent;
  if (r === 0) return Math.round(Pcent / n);
  const a = Math.pow(1 + r, n);
  const M_eur = ((Pcent / 100) * r * a) / (a - 1);
  return Math.round(M_eur * 100);
};

const splatkovyKalendar = React.useMemo(() => {
  const r = (Number(urok) || 0) / 100 / 12;
  const n = Math.max(1, (Number(roky) || 0) * 12);
  const P = Math.max(0, Number(suma) || 0);
  if (P === 0) return [];

  let zostatokC = doCentov(P);
  const Mcent = annuitnaSplatkaCenty(zostatokC, r, n);

  const riadky = [];
  for (let m = 1; m <= n && zostatokC > 0; m++) {
    const urokC = Math.round(zostatokC * r);                 
    const splatkaC = r === 0 ? Math.min(Mcent, zostatokC)    
                              : Math.min(Mcent, zostatokC + urokC);

    const istinaC = Math.max(0, splatkaC - urokC);
    zostatokC = Math.max(0, zostatokC - istinaC);

    riadky.push({
      mesiac: m,
      splatkaC,
      urokC,
      istinaC,
      zostatokC
    });
  }
  return riadky;
}, [suma, urok, roky]);


const psVstupRef = React.useRef(null);
const psVystupRef = React.useRef(null);
const invVstupRef = React.useRef(null);
const invVystupRef = React.useRef(null);
const chartRef = React.useRef(null);

const invHorizontTouched = React.useRef(false);
useEffect(() => {
  if (!invHorizontTouched.current) setInvHorizont(roky);
}, [roky]);

const dorovnanieKarietKluc = React.useMemo(() => {
  return [
    ppRezim,
    invVystupPS,
    ppJednoraz,
    ppMesacne,
    ppRocne,
    ppStart,
    ppOpakovania,
    invJednoraz,
    invMesacne,
    invZhodnotenie,
    invHorizont,
    zostatky.length,
    vysledokInvestovania?.konecnaHodnota ?? '',
    resultA?.payoffMonth ?? '',
    resultB?.payoffMonth ?? '',
  ].join('|');
}, [
  ppRezim,
  invVystupPS,
  ppJednoraz,
  ppMesacne,
  ppRocne,
  ppStart,
  ppOpakovania,
  invJednoraz,
  invMesacne,
  invZhodnotenie,
  invHorizont,
  zostatky.length,
  vysledokInvestovania?.konecnaHodnota,
  resultA?.payoffMonth,
  resultB?.payoffMonth,
]);

useDorovnajKarty({
  psVstupRef,
  psVystupRef,
  invVstupRef,
  invVystupRef,
  ppOpen,
  invOpen,
  spustac: dorovnanieKarietKluc,
});

const splatkovyKalendarPS_skratenie = React.useMemo(() => {
  if (!ppOpen || !ppClamped?.events?.length) return null;

  const r = (Number(urok) || 0) / 100 / 12;
  const n = Math.max(1, (Number(roky) || 0) * 12);
  const P = Math.max(0, Number(suma) || 0);

  const evMap = new Map();
  for (const e of ppClamped.events) {
    evMap.set(e.m, (evMap.get(e.m) || 0) + doCentov(e.amt)); 
  }

  let zostatokC = doCentov(P);
  const Mcent = annuitnaSplatkaCenty(zostatokC, r, n);
  const riadky = [];

  for (let i = 0; i < n && zostatokC > 0; i++) {
    const urokC = Math.round(zostatokC * r);
    const splatkaC = r === 0 ? Math.min(Mcent, zostatokC)
                             : Math.min(Mcent, zostatokC + urokC);

    const istinaC = Math.max(0, splatkaC - urokC);
    zostatokC = Math.max(0, zostatokC - istinaC);

    const extraC = evMap.get(i) || 0;
    if (extraC > 0) zostatokC = Math.max(0, zostatokC - extraC);

    riadky.push({
      mesiac: i + 1,
      splatkaC,
      urokC,
      istinaC,
      zostatokC
    });
  }
  return riadky;
}, [ppOpen, ppClamped, urok, roky, suma]);

const splatkovyKalendarPS_znizenie = React.useMemo(() => {
  if (!ppOpen || !ppClamped?.events?.length) return null;

  const r = (Number(urok) || 0) / 100 / 12;
  const n = Math.max(1, (Number(roky) || 0) * 12);
  const P0 = Math.max(0, Number(suma) || 0);

  const evMap = new Map();
  for (const e of ppClamped.events) {
    evMap.set(e.m, (evMap.get(e.m) || 0) + doCentov(e.amt));
  }

  let zostatokC = doCentov(P0);
  const riadky = [];

  for (let i = 0; i < n && zostatokC > 0; i++) {
    const zostava = Math.max(1, n - i);
    const McurC = annuitnaSplatkaCenty(zostatokC, r, zostava);

    const urokC = Math.round(zostatokC * r);
    const splatkaC = r === 0 ? Math.min(McurC, zostatokC)
                             : Math.min(McurC, zostatokC + urokC);

    const istinaC = Math.max(0, splatkaC - urokC);
    zostatokC = Math.max(0, zostatokC - istinaC);

    const extraC = evMap.get(i) || 0;
    if (extraC > 0) {
      zostatokC = Math.max(0, zostatokC - extraC);
    }

    riadky.push({
      mesiac: i + 1,
      splatkaC,
      urokC,
      istinaC,
      zostatokC
    });
  }
  return riadky;
}, [ppOpen, ppClamped, urok, roky, suma]);

const investicnyPriebeh = React.useMemo(() => {
  if (!invOpen) return null;

  const maVstupy = Number(invJednoraz) > 0 || Number(invMesacne) > 0;
  if (!maVstupy) return null;

  return vysledokInvestovania
    ? {
        graf: vysledokInvestovania.priebehKrivky || [],
        payoffMonth: vysledokInvestovania.mesiacSplatenia || null
      }
    : { graf: [], payoffMonth: null };
}, [invOpen, invJednoraz, invMesacne, vysledokInvestovania]);

useEffect(() => {
  if (!pdfModalOtvoreny) {
    setPdfSekcie((prev) => ({
      ...prev,
      zahrnutPredcasneSplatenie: ppOpen,
      zahrnutInvestovanie: invOpen,
      zahrnutGraf: true,
      zahrnutPoznamku: Boolean((poznamka || '').trim()),
    }));
  }
}, [ppOpen, invOpen, poznamka, pdfModalOtvoreny]);

  return (
      <>
    <Navbar />

    <TopSadzbyBanner topSadzby={topSadzby} />

    <div id="kalkulacka" className="App">
      <div className={`board ${ppOpen ? 'board--pp-open' : 'board--pp-closed'} ${invOpen ? 'board--inv-open' : 'board--inv-closed'}`}>

        {/* časť - vstupy/parametre */}
        <div className="col col--inputs">
        
          <HypoVstupneParametre
            typHypoteky={typHypoteky}
            setTypHypoteky={setTypHypoteky}
            suma={suma}
            setSuma={setSuma}
            hodnotazabezpecenia={hodnotazabezpecenia}
            setHodnotazabezpecenia={setHodnotazabezpecenia}
            ltvMoznosti={ltvMoznosti}
            setLtvMoznosti={setLtvMoznosti}
            jeNizkaHodnota={jeNizkaHodnota}
            fixacia={fixacia}
            setFixacia={setFixacia}
            fixacieRocne={fixacieRocne}
            urok={urok}
            setUrok={setUrok}
            roky={roky}
            setRoky={setRoky}
            pocetziadatelov={pocetziadatelov}
            setPocetziadatelov={setPocetziadatelov}

            setVek2={setVek2}
            setPrijem2={setPrijem2}
            setPocetdeti2={setPocetdeti2}
            setVek3={setVek3}
            setPrijem3={setPrijem3}
            setPocetdeti3={setPocetdeti3}
            setVek4={setVek4}
            setPrijem4={setPrijem4}
            setPocetdeti4={setPocetdeti4}
            setSpolocnadomacnost1={setSpolocnadomacnost1}
            setSpolocnadomacnost2={setSpolocnadomacnost2}
            setAktivnyZiadatelTab={setAktivnyZiadatelTab}

            zmJednotlivec={zmJednotlivec}
            setZmJednotlivec={setZmJednotlivec}
            zmDruhyDospely={zmDruhyDospely}
            setZmDruhyDospely={setZmDruhyDospely}
            zmDieta={zmDieta}
            setZmDieta={setZmDieta}
          />

          <HypoZiadatelia
            pocetziadatelov={pocetziadatelov}
            aktivnyZiadatelTab={aktivnyZiadatelTab}
            setAktivnyZiadatelTab={setAktivnyZiadatelTab}

            vek1={vek1}
            setVek1={setVek1}
            prijem1={prijem1}
            setPrijem1={setPrijem1}
            pocetdeti={pocetdeti}
            setPocetdeti={setPocetdeti}

            vek2={vek2}
            setVek2={setVek2}
            prijem2={prijem2}
            setPrijem2={setPrijem2}
            pocetdeti2={pocetdeti2}
            setPocetdeti2={setPocetdeti2}

            vek3={vek3}
            setVek3={setVek3}
            prijem3={prijem3}
            setPrijem3={setPrijem3}
            pocetdeti3={pocetdeti3}
            setPocetdeti3={setPocetdeti3}

            vek4={vek4}
            setVek4={setVek4}
            prijem4={prijem4}
            setPrijem4={setPrijem4}
            pocetdeti4={pocetdeti4}
            setPocetdeti4={setPocetdeti4}

            spolocnadomacnost1={spolocnadomacnost1}
            setSpolocnadomacnost1={setSpolocnadomacnost1}
            spolocnadomacnost2={spolocnadomacnost2}
            setSpolocnadomacnost2={setSpolocnadomacnost2}
          />

          <HypoZavazky
            pocetziadatelov={pocetziadatelov}
            aktivnyZavazkyTab={aktivnyZavazkyTab}
            setAktivnyZavazkyTab={setAktivnyZavazkyTab}

            Hypoobjem={Hypoobjem}
            setHypoobjem={setHypoobjem}
            Hyposplatnost={Hyposplatnost}
            setHyposplatnost={setHyposplatnost}
            Hyposadzba={Hyposadzba}
            setHyposadzba={setHyposadzba}
            Hyposplatka={Hyposplatka}
            setHyposplatka={setHyposplatka}
            Hypofixacia={Hypofixacia}
            setHypofixacia={setHypofixacia}
            Ostatneobjem={Ostatneobjem}
            setOstatneobjem={setOstatneobjem}
            Ostatnesplatka={Ostatnesplatka}
            setOstatnesplatka={setOstatnesplatka}

            Hypoobjem2={Hypoobjem2}
            setHypoobjem2={setHypoobjem2}
            Hyposplatnost2={Hyposplatnost2}
            setHyposplatnost2={setHyposplatnost2}
            Hyposadzba2={Hyposadzba2}
            setHyposadzba2={setHyposadzba2}
            Hyposplatka2={Hyposplatka2}
            setHyposplatka2={setHyposplatka2}
            Hypofixacia2={Hypofixacia2}
            setHypofixacia2={setHypofixacia2}
            Ostatneobjem2={Ostatneobjem2}
            setOstatneobjem2={setOstatneobjem2}
            Ostatnesplatka2={Ostatnesplatka2}
            setOstatnesplatka2={setOstatnesplatka2}

            Hypoobjem3={Hypoobjem3}
            setHypoobjem3={setHypoobjem3}
            Hyposplatnost3={Hyposplatnost3}
            setHyposplatnost3={setHyposplatnost3}
            Hyposadzba3={Hyposadzba3}
            setHyposadzba3={setHyposadzba3}
            Hyposplatka3={Hyposplatka3}
            setHyposplatka3={setHyposplatka3}
            Hypofixacia3={Hypofixacia3}
            setHypofixacia3={setHypofixacia3}
            Ostatneobjem3={Ostatneobjem3}
            setOstatneobjem3={setOstatneobjem3}
            Ostatnesplatka3={Ostatnesplatka3}
            setOstatnesplatka3={setOstatnesplatka3}

            Hypoobjem4={Hypoobjem4}
            setHypoobjem4={setHypoobjem4}
            Hyposplatnost4={Hyposplatnost4}
            setHyposplatnost4={setHyposplatnost4}
            Hyposadzba4={Hyposadzba4}
            setHyposadzba4={setHyposadzba4}
            Hyposplatka4={Hyposplatka4}
            setHyposplatka4={setHyposplatka4}
            Hypofixacia4={Hypofixacia4}
            setHypofixacia4={setHypofixacia4}
            Ostatneobjem4={Ostatneobjem4}
            setOstatneobjem4={setOstatneobjem4}
            Ostatnesplatka4={Ostatnesplatka4}
            setOstatnesplatka4={setOstatnesplatka4}
          />
        
          <PoznamkaKarta
            poznamka={poznamka}
            setPoznamka={setPoznamka}
          />
          
          <RozsireneMoznostiKarta
            ppOpen={ppOpen}
            setPpOpen={setPpOpen}
            invOpen={invOpen}
            setInvOpen={setInvOpen}
            skalRezim={skalRezim}
            setSkalRezim={setSkalRezim}
          />

          <PredcasneSplatenieVstupKarta
            ref={psVstupRef}
            ppOpen={ppOpen}
            ppRezim={ppRezim}
            setPpRezim={setPpRezim}
            ppJednoraz={ppJednoraz}
            setPpJednoraz={setPpJednoraz}
            ppMesacne={ppMesacne}
            setPpMesacne={setPpMesacne}
            ppRocne={ppRocne}
            setPpRocne={setPpRocne}
            ppStart={ppStart}
            setPpStart={setPpStart}
            ppOpakovania={ppOpakovania}
            setPpOpakovania={setPpOpakovania}
            celkovoMesiacovPP={celkovoMesiacovPP}
            startMoznost={startMoznost}
            repeatValueEfekt={repeatValueEfekt}
            opakovaniaMoznost={opakovaniaMoznost}
            ppClamped={ppClamped}
          />

          {/*  časť - sporenie/investovanie  */}
          <InvestovanieVstupKarta
            ref={invVstupRef}
            invOpen={invOpen}
            invProfil={invProfil}
            setInvProfil={setInvProfil}
            setInvZhodnotenie={setInvZhodnotenie}
            invVystupPS={invVystupPS}
            setInvVystupPS={setInvVystupPS}
            invJednoraz={invJednoraz}
            setInvJednoraz={setInvJednoraz}
            invMesacne={invMesacne}
            setInvMesacne={setInvMesacne}
            invZhodnotenie={invZhodnotenie}
            invHorizont={invHorizont}
            setInvHorizont={setInvHorizont}
            invHorizontTouched={invHorizontTouched}
          />
        </div>
        

        {/* analytická časť */}
        <div className="col col--analytics">
          <VypoctyKarta
            suma={suma}
            hodnotazabezpecenia={hodnotazabezpecenia}
            urok={urok}
            fixacia={fixacia}
            roky={roky}
            splatka={splatka}
            stresssplatka={stresssplatka}
            dtiVysledok={dtiVysledok}
            stressdti={stressdti}
            dstistresssplatka={dstistresssplatka}
            maFincloudTip={maFincloudTip}
            fincloudTip={fincloudTip}
            fincloudTipPlaceholder={fincloudTipPlaceholder}
            resetujAplikaciu={resetujAplikaciu}
            ulozPonukuPdf={otvorPdfModal}
          />

          <VyvojGrafKarta
            zostatky={zostatky}
            data={data}
            chartOptions={chartOptions}
            chartRef={chartRef}
          />

          <PredcasneSplatenieVystupKarta
            ref={psVystupRef}
            ppOpen={ppOpen}
            ppRezim={ppRezim}
            resultA={resultA}
            resultB={resultB}
            preplatenieBezPS={preplatenieBezPS}
            fmtMesiace={fmtMesiace}
            rozdielMesiacov={rozdielMesiacov}
            exceededRelevant={exceededRelevant}
            ppDraft={ppDraft}
          />

          <InvestovanieVystupKarta
            ref={invVystupRef}
            invOpen={invOpen}
            invVystupPS={invVystupPS}
            invHorizont={invHorizont}
            invZhodnotenie={invZhodnotenie}
            vysledokInvestovania={vysledokInvestovania}
            fmtMesiace={fmtMesiace}
            rozdielMesiacov={rozdielMesiacov}
          />

        
      </div>     {/* koniec .col col--analytics */}

      <SplatkovyKalendarKarta
        skalRezim={skalRezim}
        splatkovyKalendar={splatkovyKalendar}
        splatkovyKalendarPS_skratenie={splatkovyKalendarPS_skratenie}
        splatkovyKalendarPS_znizenie={splatkovyKalendarPS_znizenie}
        investicnyPriebeh={investicnyPriebeh}
        ppOpen={ppOpen}
        ppClamped={ppClamped}
        ppRezim={ppRezim}
      />

        <PorovnavacBank
          typHypoteky={typHypoteky}
          suma={suma}
          roky={roky}
          hodnotazabezpecenia={hodnotazabezpecenia}
          fixacia={fixacia}

          pocetziadatelov={pocetziadatelov}
          pocetdeti={pocetdeti}
          pocetdeti2={pocetdeti2}
          pocetdeti3={pocetdeti3}
          pocetdeti4={pocetdeti4}

          spolocnadomacnost1={spolocnadomacnost1}
          spolocnadomacnost2={spolocnadomacnost2}

          vek1={vek1}
          prijem1={prijem1}
          vek2={vek2}
          prijem2={prijem2}
          vek3={vek3}
          prijem3={prijem3}
          vek4={vek4}
          prijem4={prijem4}

          Hypoobjem={Hypoobjem}
          Hyposplatnost={Hyposplatnost}
          Hyposadzba={Hyposadzba}
          Hyposplatka={Hyposplatka}
          Hypofixacia={Hypofixacia}
          Ostatneobjem={Ostatneobjem}
          Ostatnesplatka={Ostatnesplatka}

          Hypoobjem2={Hypoobjem2}
          Hyposplatnost2={Hyposplatnost2}
          Hyposadzba2={Hyposadzba2}
          Hyposplatka2={Hyposplatka2}
          Hypofixacia2={Hypofixacia2}
          Ostatneobjem2={Ostatneobjem2}
          Ostatnesplatka2={Ostatnesplatka2}

          Hypoobjem3={Hypoobjem3}
          Hyposplatnost3={Hyposplatnost3}
          Hyposadzba3={Hyposadzba3}
          Hyposplatka3={Hyposplatka3}
          Hypofixacia3={Hypofixacia3}
          Ostatneobjem3={Ostatneobjem3}
          Ostatnesplatka3={Ostatnesplatka3}

          Hypoobjem4={Hypoobjem4}
          Hyposplatnost4={Hyposplatnost4}
          Hyposadzba4={Hyposadzba4}
          Hyposplatka4={Hyposplatka4}
          Hypofixacia4={Hypofixacia4}
          Ostatneobjem4={Ostatneobjem4}
          Ostatnesplatka4={Ostatnesplatka4}

          onZmenaDatPrePdf={setPorovnavacDataPrePdf}
        />


    </div>       {/* koniec .board */}
  </div>         {/* koniec #kalkulacka */}
            
  <ExportPonukaPdfModal
      jeOtvoreny={pdfModalOtvoreny}
      nazovSuboruPdf={nazovSuboruPdf}
      setNazovSuboruPdf={setNazovSuboruPdf}
      menoKlientaPdf={menoKlientaPdf}
      setMenoKlientaPdf={setMenoKlientaPdf}
      pdfSekcie={pdfSekcie}
      setPdfSekcie={setPdfSekcie}
      onZavriet={() => setPdfModalOtvoreny(false)}
      onPotvrdit={ulozPonukuPdf}
    />


    {/* dočasná predpríprava */}
    <div id="metodika" />
    <div id="investicna" />
    <div id="dokumenty" />
    <div id="admin" />
  </>
);
}

export default HypotekarnaKalkulacka;
